const ACTIVE_ENV = 'PROD';
const ENVS = {
  DEV: {
    BASE_URL: 'https://api.dev.hav-g.in/',
    CAPI_URL: 'https://public-zxhj2.dev.hav-g.in/',
    AUTH_TOKEN: 'e2623576-930b-48b6-81e2-a3cb5e37f47d',
  },
  PROD: {
    BASE_URL: 'https://api.hav-g.in/',
    CAPI_URL: 'https://public-jgfas325.hav-g.in/',
    AUTH_TOKEN: 'd7ef603e-71ea-44a1-93f2-2bacd08c4a90',
  },
};

const ENV = ENVS[ACTIVE_ENV];
let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
const CONFIG = {
  BASE_URL: ENV.BASE_URL,
  CAPI_URL: ENV.CAPI_URL,
  AUTH_HEADER: { Authorization: `Bearer ${ENV.AUTH_TOKEN}` },
  JSON_HEADERS: { 'Content-Type': 'application/json' },
};

const state = {
  id: null,
  caseId: null,
  f_name: null,
  C_number: null,
  C_email: null,
  user_gender: null,
  userHairStage: null,
  pdPrice: 0,
  strikeFinalCartPrice: 0,
  apiStrikePrice: 0,
};

function getCookieValue(name) {
  const match = document.cookie.split(';').find(c => c.trim().startsWith(name + '='));
  return match ? match.trim().split('=').slice(1).join('=') : null;
}
function getUrlParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}
function qs(selector, root = document) {
  return root.querySelector(selector);
}
function qsa(selector, root = document) {
  return root.querySelectorAll(selector);
}

function normalizeDosageText(value) {
  if (!value) return value;
  return value
    .replace(/\bTABS\b/gi, 'Tablets')
    .replace(/\bTAB\b/gi,  'Tablet');
}

// ── PRODUCT IMAGE URL HELPER ──────────────────────────────────────────────────
function getProductImageUrl(key) {
  if (!key) return '';
  if (key.startsWith('http')) return key;
  return `https://cdn.shopify.com/s/files/1/0100/1622/7394/files/${key}.webp`;
}

// ── MOENGAGE EVENT TRACKER ────────────────────────────────────────────────────
function trackMoengageEvent(eventName) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      eventName,
      eventAttributes: {
        generalAttributes: {
          platform: "web_shopify",
          domain: "traya.health",
          syntheticId: getUrlParam('id') || "default-id"
        }
      },
      caseId: state.caseId
    })
  });
}
// ─────────────────────────────────────────────────────────────────────────────

(function init() {
  // ── Wait for ALL_PRODUCTS to be defined by product-data.js ──
  if (typeof ALL_PRODUCTS === 'undefined') {
    return setTimeout(init, 50);
  }

  const urlId = getUrlParam('id');
  if (urlId) {
    localStorage.setItem('user-gender', 'female');
    localStorage.setItem('rid', urlId);
  }

  state.id = localStorage.getItem('rid') || getCookieValue('syntheticId');

  if (!state.id) {
    if (window.location.pathname === '/pages/result4') {
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      window.location.href = 'https://form.traya.health/questions?cohort=1&source=ResultPage';
    }
    return;
  }
  document.body.style.overflow = 'unset';
  setotherCookie('syntheticId', state.id, 30, '.traya.health');
  fetchFemaleResult();
})();

function fetchFemaleResult() {
  const url = `${CONFIG.BASE_URL}dgReport/female?id=${state.id}&isWebsite=true`;
  document.body.style.overflow = 'hidden';

  fetch(url, { headers: CONFIG.AUTH_HEADER })
    .then(res => res.json())
    .then(handleFemaleResult)
    .catch(err => console.error('Network Error:', err))
    .finally(() => {
      document.body.style.overflow = '';
      clearCart();
    });
}

function trackMetaEvent(analysis, eventName) {
  const body = {
    eventName,
    eventTime: Date.now(),
    email: analysis.email,
    phone: analysis.phone,
    fbc: getCookieValue('_fbc'),
    fbp: getCookieValue('_fbp'),
    url: window.location.href,
    domain: 'traya.health',
    gender: analysis.gender,
  };

  fetch(`${CONFIG.CAPI_URL}tracking`, {
    method: 'POST',
    headers: { ...CONFIG.JSON_HEADERS, ...CONFIG.AUTH_HEADER },
    body: JSON.stringify(body),
  });
}

function clearCart() {
  $.getJSON('/cart.js', function(cart) {
    if (cart.item_count === 0) { silentCheckout(); return; }
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: silentCheckout,
      error: err => console.error('Error clearing cart:', err),
    });
  });
}

function silentCheckout() {
  setCartButtonState('loading');
  localStorage.setItem('user__gender', state.user_gender);
  localStorage.setItem('caseId', state.caseId);

  const userGender = state.user_gender === 'F' ? 'Female' : state.user_gender;

  const items = (window.API_PRODUCTS || []).map(item => ({
    id: Number(item.product_id),
    quantity: 1,
    properties: {
      Plan: 'Auto',
    }
  }));

  const formData = {
    items,
    attributes: {
      first_name: state.f_name,
      phone: state.C_number,
      email: state.C_email,
      caseid: state.caseId,
      user__gender: userGender,
      hair_Stage: state.userHairStage,
    }
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: CONFIG.JSON_HEADERS,
    body: JSON.stringify(formData),
  })
    .then(res => res.json())
    .then(() => localStorage.setItem('User_location', 'cart'))
    .catch(err => console.error('Silent checkout error:', err))
    .finally(() => setTimeout(() => {
      setCartButtonState('ready');
      updateCartDrawer();
    }, 800));
}

const LOADER_SVG = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" class="loader-icon" alt="Loading...">`;
const LOADER_BTN = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123" class="loader-icon" alt="Loading..." />`;

function setCartButtonState(state) {
  qsa('#add-to-cart-result-page-frp').forEach(btn => {
    const isLoading = state === 'loading';
    btn.innerHTML = isLoading ? LOADER_SVG : 'Buy Now';
    btn.disabled = isLoading;
    btn.classList.toggle('loader-added', isLoading);
  });
}

function updateCartDrawer() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const updates = Object.fromEntries(
        cart.items
          .filter(item => item.quantity === 2)
          .map(item => [item.key, 1])
      );

      if (Object.keys(updates).length === 0) return refreshCartUI();

      fetch('/cart/update.js', {
        method: 'POST',
        headers: CONFIG.JSON_HEADERS,
        body: JSON.stringify({ updates }),
      })
        .then(res => res.json())
        .then(refreshCartUI)
        .catch(err => console.error('Error updating quantities:', err));
    });
}

async function refreshCartUI() {
  try {
    const [bubbleData, drawerData] = await Promise.all([
      fetch('/?sections=cart-icon-bubble').then(r => r.json()),
      fetch('/?sections=cart-drawer').then(r => r.json()),
    ]);

    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && bubbleData['cart-icon-bubble']) {
      cartIconBubble.innerHTML = bubbleData['cart-icon-bubble'];
    }

    const cartDrawer = qs('cart-drawer');
    if (cartDrawer && drawerData['cart-drawer']) {
      cartDrawer.outerHTML = drawerData['cart-drawer'];
      setTimeout(bindCartDrawerEvents, 50);
      qsa('.cart-drawer .cart-item cart-remove-button, .cart-drawer quantity-input.quantity')
        .forEach(el => (el.style.display = 'none'));
    }
   requestAnimationFrame(() => {
    qsa('.totals__subtotal-value .strike-cart-total-price').forEach(el => {
      el.textContent = `₹ ${state.pdPrice}`;
    });
  });

  } catch (err) {
    console.error('Error refreshing cart UI:', err);
  }
}

function bindCartDrawerEvents() {
  qs('.drawer__close')?.addEventListener('click', () => {
    qs('cart-drawer.drawer')?.classList.remove('active');
    qs('.cart-drawer__overlay')?.classList.remove('active');
  });
}

bindCartDrawerEvents();

// ← add here
window.addEventListener('pageshow', (e) => {
  if (e.persisted) {
    qsa('#add-to-cart-result-page-frp').forEach(btn => {
      btn.innerHTML = 'Buy Now';
      btn.classList.remove('loader-added');
      btn.disabled = false;
    });
  }
});

// ── DOSAGE PATCH ─────────────────────────────────────────────────────────
const SHINE_SERUM_VARIANT_ID = '47301148803250';
const ANTI_DANDRUFF_SHAMPOO_VARIANT_ID = '47329496826034';

function applyDosagePatch(p) {
  const name = p.product?.toLowerCase() || '';

  // Shine Serum → hair wash day
  if (name.includes('shine') || String(p.variant_id) === SHINE_SERUM_VARIANT_ID) {
    if (!p.dosage) p.dosage = {};
    p.dosage.hair_wash_day = 'Twice a week';
  }

  // Santulan → 2 Tablets morning & night
  if (name.includes('santulan')) {
    p.dosage = p.dosage || {};
    if (!p.dosage.morning) p.dosage.morning = '2 Tablets';
    if (!p.dosage.night)   p.dosage.night   = '2 Tablets';
  }

  // Anti Dandruff Shampoo → hair wash day
  if (name.includes('anti dandruff shampoo') || String(p.variant_id) === ANTI_DANDRUFF_SHAMPOO_VARIANT_ID) {
    p.dosage = p.dosage || {};
    if (!p.dosage.hair_wash_day) p.dosage.hair_wash_day = 'During wash';
  }

  // Hair Ras → force 2 Tablets morning & night
  if (name.includes('hair ras')) {
    p.dosage = p.dosage || {};
    p.dosage.morning = '2 Tablets';
    p.dosage.night   = '2 Tablets';
  }
}
// ─────────────────────────────────────────────────────────────────────────────

function handleFemaleResult(response) {
  if (response.message === 'Report is only for female') {
    window.location.href = `/pages/result4${window.location.search}`;
    return;
  }

  const analysis = response?.User_Analysis ?? {};
  state.caseId       = analysis.case_id;
  caseId             = state.caseId;
  tagClarityCaseId(caseId);
  state.userHairStage = analysis.hair_fall_stage?.toLowerCase();
  state.f_name       = analysis.first_name  || null;
  state.C_number     = analysis.phone       || null;
  state.C_email      = analysis.email       || null;
  state.user_gender  = analysis.gender      || null;
  state.strikeFinalCartPrice = Math.round(response.newPriceCard.updatedCartPrice);
  state.apiStrikePrice = Math.round(response.newPriceCard.updatedCartPrice);

  const validStage = state.userHairStage === "hair thinning"
    || state.userHairStage === "side thinning"
    || state.userHairStage === "no widening";

  const hairThinningExpectation = document.querySelector(".results-timeline-progress");
  const wideningExpectation = document.querySelector(".shopify-section.month-expectation--section");

  if (validStage) {
    if (wideningExpectation) wideningExpectation.classList.add('d-none');
  } else {
    if (hairThinningExpectation) hairThinningExpectation.classList.add('d-none');
  }

  const apiProducts = response?.product_Ids || [];
  window.API_PRODUCTS = apiProducts;
  const productMap = new Map();
  window.API_PRICE_MAP = {};
  apiProducts.forEach(p => {
    window.API_PRICE_MAP[String(p.product_id)] = p.price;
  });
  ALL_PRODUCTS.forEach(p => {
    productMap.set(String(p.variant_id), p);
  });

  const matchedProducts = [];
  apiProducts.forEach(apiItem => {
    const id = String(apiItem.product_id);
    if (productMap.has(id)) {
      matchedProducts.push(productMap.get(id));
    } else {
      console.warn("No match for API product_id:", id);
    }
  });
  matchedProducts.forEach(applyDosagePatch);

  console.log("MATCHED PRODUCTS:", matchedProducts);

  initCombo(matchedProducts);
  recalculatePrices();
  userDetails(response);
  trackMetaEvent(analysis, 'Viewed Content');
  displayStageSection(response);
  buildTimeline(getTimelineData(response));
  initResultsPopup();
  if (trayaProcessingAnimation) {
    trayaProcessingAnimation.style.display = 'none';
  }
  document.body.style.overflow = 'unset';
}

// ── HAIR STAGE TAG MAP ─────────────────────────────────────────────────────
const HAIR_STAGE_TAG_MAP = {
  "hair thinning": {
    title: "Thinning & Less Volume",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/thinning_less_volume_b099f614-36ea-48f9-a746-8283dbb97a60.webp?v=1776067672"
  },
  "side thinning": {
    title: "Side Thinning & Less Volume",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/side_thinning_less_volume_1a43d2d9-b4eb-4525-afb7-818b4a2ad545.webp"
  },
  "medium widening": {
    title: "Visible Scalp & Wide Partition",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/partition_widening_7e95914a-201d-44d9-b566-4a5cc537645d.webp"
  },
  "advanced widening": {
    title: "Visible Scalp & Wide Partition",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/partition_widening_7e95914a-201d-44d9-b566-4a5cc537645d.webp"
  },
  "coin size patches": {
    title: "Visible Scalp Patches",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_patches_fc475437-504d-4287-bf83-868d07a25570.webp"
  },
  "alopecia areata": {
    title: "Visible Scalp Patches",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/scalp_patches_fc475437-504d-4287-bf83-868d07a25570.webp"
  },
  "no widening": {
    title: "Thinning & Less Volume",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Thinning_less_volume.webp?v=1774856266"
  }
};

function getHairConditionData(stage) {
  const normalized = stage?.toLowerCase()?.trim();
  return HAIR_STAGE_TAG_MAP[normalized] || { title: stage, image: "" };
}

// ── HAIR FALL INTENSITY MAP ────────────────────────────────────────────────
const HAIR_FALL_INTENSITY_MAP = {
  "normal hair fall": {
    title: "Normal Hair Fall",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/normal-hair-fall.webp"
  },
  "excessive hair fall": {
    title: "Excessive Hair Fall",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/excessive_hair_fall_aee042aa-1677-4c32-b207-0f77aa3ae5ba.webp"
  },
  "severe hair fall": {
    title: "Severe Hair Fall",
    image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/severe_hair_fall_c8c464a4-5342-4b4e-ba53-6bf583ade2ed.webp"
  }
};

function getHairFallData(intensity) {
  const normalized = intensity?.toLowerCase()?.trim();
  return HAIR_FALL_INTENSITY_MAP[normalized] || { title: intensity, image: "" };
}

function userDetails(response) {
  let { User_Analysis } = response;
  let userName = qsa('#user-name');
  let reportStageContent = qs('#hair-condition');
  let hairFallCondition = qs("#hair-fall-condition");

  if (userName) {
    userName.forEach((name) => {
      name.innerHTML = `Hi, <span>${User_Analysis.first_name}</span><br> <span class="hair-condition-text" style="margin-top: 8px; display: block;">We know exactly what's happening with your hair</span>`;
    });
  }
  if (reportStageContent) {
    const stage = response?.User_Analysis?.hair_fall_stage;
    const data = getHairConditionData(stage);
    reportStageContent.innerHTML = `
      <div class="hair-stage-wrapper">
        ${data.image ? `<img src="${data.image}" alt="${data.title}" class="hair-stage-image" width="44px" height="44px" />` : ""}
        <p class="hair-stage-title">${data.title}</p>
      </div>
    `;
  }
  if (hairFallCondition) {
    const data = getHairFallData(User_Analysis.hairFallIntensity);
    hairFallCondition.innerHTML = `
      <div class="hair-fall-item">
        ${data.image ? `<img src="${data.image}" class="hair-fall-icon" />` : ""}
        <p class="hair-fall-text">${data.title}</p>
      </div>
    `;
  }

  const buyButtons = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtons.forEach((btn) => {
    btn.addEventListener('click', handleCheckoutClick);
  });

 function handleCheckoutClick(e) {
  const btn = e.currentTarget;
  if (btn.disabled) return;

  // ✅ loader
  btn.innerHTML = `
    <img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123" 
    class="loader-icon" alt="Loading..." />
  `;
  btn.classList.add('loader-added');
  btn.disabled = true;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      // ✅ if cart empty → restore + go to cart
      if (cart.items.length === 0) {

        const items = ORIGINAL_PRODUCTS.map(p => ({
          id: Number(p.variant_id),
          quantity: 1,
        }));

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: CONFIG.JSON_HEADERS,
          body: JSON.stringify({ items }),
        }).then(() => {
          window.location.href = '/cart';
        });

      } else {
        // ✅ normal flow
        window.location.href = '/checkout';
      }
    });

  // ✅ safety reset (same as your reference file)
  setTimeout(() => {
    btn.innerHTML = 'Buy Now';
    btn.classList.remove('loader-added');
    btn.disabled = false;
  }, 2000);
}

  }

// ─── STAGE SECTION ───────────────────────────────────────────────────────────

const STAGE_IMAGES = {
  "hair thinning": {
    customerName: "Pooja",
    images: [
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/pooja-Image.png?v=1774869054",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/pooja-Image-1.png?v=1774869054",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/pooja-Image-2.png?v=1774869054",
    ],
  },
  "medium widening": {
    customerName: "Poonam",
    images: [
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/poonam-Image.png?v=1774869112",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/poonam-Image-1.png?v=1774869112",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/poonam-Image-2.png?v=1774869112",
    ],
  },
  "advanced widening": {
    customerName: "Pratima",
    images: [
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/pratima-Image.png?v=1774869168",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/pratima-Image-1.png?v=1774869168",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/pratima-Image-2.png?v=1774869168",
    ],
  },
  "side thinning": {
    customerName: "Anjali",
    images: [
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/anjali-Image.png?v=1774869179",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/anjali-Image-1.png?v=1774869179",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/anjali-Image-2.png?v=1774869179",
    ],
  },
  "coin size patches": {
    customerName: "Supriya",
    images: [
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/supriya-Image.png?v=1774869246",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/supriya-Image-1.png?v=1774869246",
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/supriya-Image-2.png?v=1774869247",
    ],
  },
};

STAGE_IMAGES["alopecia areata"] = STAGE_IMAGES["coin size patches"];

function displayStageSection(response) {
  const stageContainer = document.getElementById('customer-report-journey');
  if (!stageContainer) return;

  const userStage = response?.User_Analysis?.hair_fall_stage?.toLowerCase();
  const stageData = STAGE_IMAGES[userStage];

  stageContainer.innerHTML = '';
  if (!stageData) return;

  const MONTH_LABELS = [1, 3, 5];
  stageContainer.innerHTML = `
    <p class="custome-stage-heading">
      Here's ${stageData.customerName}, <br> She was exactly where you are
    </p>
    <div class="stage-image-wrapper">
      ${stageData.images.map((imgUrl, index) => `
        <div class="scrollable-stage-image-wrapper">
          <img src="${imgUrl}" alt="${userStage}" class="scrollable-stage-image" loading="lazy"/>
          <p>Month ${MONTH_LABELS[index]}</p>
        </div>
      `).join('')}
    </div>
  `;
}

// ─── TIMELINE ────────────────────────────────────────────────────────────────

function getTimelineData(response) {
  const resultsTimeline = {
    nonDandruff: [
      { month: "Month-1", heading: "Scalp health improves",
        subheading: "Your scalp is being nourished & balanced, so it is ready for the solution.",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_1.webp?v=1769089803",
        milestone: false },
      { month: "Month-2", heading: "Weak detached hair falls",
        subheading: "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_2.webp?v=1769089793",
        milestone: false },
      { month: "Month-3", heading: "Hair fall under Control",
        subheading: "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_3.webp?v=1769089850",
        milestone: true },
      { month: "Month-4", heading: "Faster Hair Growth",
        subheading: "Your hair grows at a healthy speed and starts feeling softer & smoother.",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_4.webp?v=1769089899",
        milestone: false },
      { month: "Month-5", heading: "Thick Dense Hair, Fuller Scalp",
        subheading: "Your scalp starts feeling fuller as hairfall is less & hair growth is fast",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_5.webp?v=1769089986",
        milestone: true },
      { month: "Month-6", heading: "Healthy Hair - Strong from Root",
        subheading: "Continue maintaining your hair with Traya serum and oil for continued results.",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_6.webp?v=1769090000",
        milestone: false }
    ],
    dandruff: [
      { month: "Month-1", heading: "Visible dandruff reduction",
        subheading: "Dandruff clears up so your scalp is cleaner and less irritated",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_0.webp?v=1770014538",
        milestone: false },
      { month: "Month-2", heading: "Scalp health improves further",
        subheading: "Your scalp is being nourished & balanced, so it is ready for the treatment",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_1.webp?v=1769089803",
        milestone: false },
      { month: "Month-3", heading: "Weak detached hair falls",
        subheading: "New strong hair pushes old detached hair out of the root. You may notice some increased hairfall. It's part of the process and only lasts 4 weeks",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_2.webp?v=1769089793",
        milestone: false },
      { month: "Month-4", heading: "Hair fall under control",
        subheading: "You notice less hairfall during combing, oiling, shampooing, as the new strong hair is strongly attached to the hair roots",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_3.webp?v=1769089850",
        milestone: true },
      { month: "Month-5", heading: "Faster Hair Growth",
        subheading: "Your hair grows at a healthy speed and starts feeling softer & smoother.",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_4.webp?v=1769089899",
        milestone: false },
      { month: "Month-6", heading: "Thick Dense Hair, Fuller Scalp",
        subheading: "Your scalp starts feeling fuller as hairfall is less & hair growth is fast",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/month_5.webp?v=1769089986",
        milestone: true },
      { month: "Month-7", heading: "Healthy Hair - Strong from Root",
        subheading: "Continue maintaining your hair with Traya serum and oil for continued results.",
        image: "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Month_6.webp?v=1769090000",
        milestone: false }
    ]
  };

  const defaultRC     = response?.root_causes?.defaultRootCause || [];
  const primaryRC     = response?.root_causes?.primaryRootCause  || [];
  const allRootCauses = [...defaultRC, ...primaryRC];
  const hasDandruff   = allRootCauses.some(rc => rc?.key?.toLowerCase().includes("dandruff"));

  return hasDandruff ? resultsTimeline.dandruff : resultsTimeline.nonDandruff;
}

const GAP      = 4;
const PEEK_PCT = 0.14;

let current          = 0;
let activeData       = [];
let stepPx           = 0;
let celebrateTimeout = null;
let CONFETTI_SRC     = '';

let outer, viewport, track, navWrap, overlay, confettiImg;

function initElements() {
  outer       = document.getElementById('carouselOuter');
  viewport    = document.getElementById('carouselViewport');
  track       = document.getElementById('track');
  navWrap     = document.getElementById('navWrap');
  overlay     = document.getElementById('celebrateOverlay');
  confettiImg = document.getElementById('confettiImg');
  CONFETTI_SRC = confettiImg ? confettiImg.src : '';
}

function setupDimensions() {
  if (!outer) return;

  const cardW  = 260;
  const peekPx = Math.round((outer.offsetWidth - cardW) / 2);

  viewport.style.padding = `12px ${peekPx}px 16px`;

  document.querySelectorAll('.exp-milestone-card').forEach(c => {
    c.style.width     = cardW + 'px';
    c.style.flexBasis = cardW + 'px';
  });

  stepPx = cardW + GAP;
  updateTrack();
}

let confettiAnim;
function buildTimeline(data) {
  initElements();

  activeData        = data;
  current           = 0;
  track.innerHTML   = '';
  navWrap.innerHTML = '';

  const hasDandruff = data.length === 7;
  navWrap.classList.toggle('dandruff-milestone', hasDandruff);

  data.forEach((item, i) => {
    const card = document.createElement('div');
    card.className = 'exp-milestone-card'
      + (item.milestone ? ' exp-milestone-highlight' : '')
      + (i === 0        ? ' is-active'               : '');

    let inner = item.milestone
      ? `<div class="exp-milestone-ribbon">Milestone</div>` : '';

    inner += `
      <div class="exp-milestone-month">${item.month}</div>
      <img class="exp-milestone-img" src="${item.image}" alt="${item.heading}" loading="lazy" />
      <div class="exp-milestone-heading">${item.heading}</div>
      <div class="exp-milestone-subheading">${item.subheading}</div>
    `;
    card.innerHTML = inner;
    track.appendChild(card);

    const navItem = document.createElement('div');
    navItem.className = 'exp-milestone-nav-item' + (item.milestone ? ' exp-milestone-flag' : '');

    const label = item.month === 'Traya for life' ? '★' : String(i + 1);
    navItem.innerHTML = `
      <button class="exp-milestone-nav-btn${i === 0 ? ' active' : ''}" data-index="${i}">
        ${label}
      </button>

      ${item.milestone ? `
        <div class="milestone-lottie" id="lottie-${i}"></div>
      ` : ''}
    `;
    navWrap.appendChild(navItem);
    let lottieInstances = [];

    if (item.milestone) {
      const anim = lottie.loadAnimation({
        container: navItem.querySelector(`#lottie-${i}`),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/purpal.json?v=1775205715'
      });

      lottieInstances.push(anim);
    }
  });

  setupDimensions();

  navWrap.addEventListener('click', e => {
    const btn = e.target.closest('.exp-milestone-nav-btn');
    if (btn) {
      trackMoengageEvent('expectation_setting_clicked_rp');
      goTo(parseInt(btn.dataset.index));
    }
  });

  let touchStartX = 0;
  track.addEventListener('touchstart', e => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  track.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 40) {
      goTo(dx < 0
        ? Math.min(current + 1, activeData.length - 1)
        : Math.max(current - 1, 0));
    }
  });

  confettiAnim = lottie.loadAnimation({
    container: document.getElementById('confettiAnimation'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Feedback_92c7f1a8-68d2-4765-9fb4-e2cb9e12e043.json?v=1775196485'
  });

  window.addEventListener('resize', setupDimensions);

  // ─── AUTO SCROLL ─────────────────────────────────────────────────────────
  let autoScrollInterval = null;
  let userInteracted = false;

  function startAutoScroll() {
    if (autoScrollInterval) return;
    autoScrollInterval = setInterval(() => {
      if (userInteracted) return;
      const next = current + 1 < activeData.length ? current + 1 : 0;
      goTo(next);
    }, 3000);
  }

  function stopAutoScroll() {
    clearInterval(autoScrollInterval);
    autoScrollInterval = null;
  }

  track.addEventListener('touchstart', () => {
    userInteracted = true;
    stopAutoScroll();
  }, { passive: true });

  navWrap.addEventListener('click', () => {
    userInteracted = true;
    stopAutoScroll();
  });

  const sectionWrap = document.querySelector('.exp-milestone-section-wrap');
  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        userInteracted = false;
        startAutoScroll();
      } else {
        stopAutoScroll();
      }
    });
  }, { threshold: 0.3 });

  if (sectionWrap) {
    sectionObserver.observe(sectionWrap);
  }
}

function goTo(index) {
  document.querySelectorAll('.exp-milestone-card').forEach((c, i) =>
    c.classList.toggle('is-active', i === index)
  );
  document.querySelectorAll('.exp-milestone-nav-btn').forEach((b, i) =>
    b.classList.toggle('active', i === index)
  );
  current = index;
  updateTrack();
  if (activeData[index].milestone) triggerCelebrate();
}

function updateTrack() {
  if (!track) return;
  track.style.transform = `translateX(-${current * stepPx}px)`;
}

function triggerCelebrate() {
  if (!overlay || !confettiAnim) return;

  if (celebrateTimeout) clearTimeout(celebrateTimeout);

  overlay.classList.add('active');
  confettiAnim.stop();
  confettiAnim.goToAndPlay(0, true);

  celebrateTimeout = setTimeout(() => {
    overlay.classList.remove('active');
  }, 2500);
}

function getProductPrices(p) {
  const variantId = String(p.variant_id);

  const bundleItem = bundleMap.bundle1.find(
    b => String(b.variantId) === variantId
  );

  const finalPrice = parseFloat(
    window.API_PRICE_MAP?.[variantId] ||
    bundleItem?.price ||
    p.price ||
    0
  );

  const originalPrice = parseFloat(
    p.compare_at_price ||
    p.original_price ||
    bundleItem?.originalPrice ||
    finalPrice ||
    0
  );

  return { finalPrice, originalPrice };
}

function updateAllPrices() {
  const finalPrice = state.pdPrice;
  const strikePrice = state.pdPrice + 500 + 199;

  document.querySelectorAll('.total-price').forEach(el => {
    el.innerText = `₹ ${finalPrice}`;
  });

  document.querySelectorAll('.strike-cart-total-price').forEach(el => {
    el.innerText = `₹ ${strikePrice}`;
  });

  const saved = strikePrice - finalPrice;

  document.querySelectorAll('.price-saved-amount').forEach(el => {
    el.innerText = `₹ ${saved}`;
  });
}

function recalculatePrices() {
  let finalTotal = 0;
  let addonStrikeDelta = 0;

  COMBO_STATE.selected.forEach(p => {
    const { finalPrice, originalPrice } = getProductPrices(p);
    finalTotal += finalPrice;

    const isAddon = ADDON_IDS.includes(String(p.variant_id));
    if (isAddon) {
      addonStrikeDelta += originalPrice;
    }
  });

  state.pdPrice = Math.round(finalTotal);
  state.strikeFinalCartPrice = state.apiStrikePrice + addonStrikeDelta;

  updateAllPrices();
  // // ── show empty cart popup the instant price hits 0 ──
  // if (state.pdPrice === 0 && COMBO_STATE.selected.length === 0) {
  //   showEmptyCartPopup();
  // }
}

const COMBO_STATE = {
  selected: [],
  removed: [],
  pendingRemove: null
};

// ── ORIGINAL PRODUCTS SNAPSHOT ────────────────────────────────────────────────
// Stores the full initial product list so we can restore it if the cart is emptied
let ORIGINAL_PRODUCTS = [];
// ─────────────────────────────────────────────────────────────────────────────

const CartManager = {
  async get() {
    return fetch('/cart.js').then(res => res.json());
  },

  async add(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: CONFIG.JSON_HEADERS,
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    });
  },

  async remove(variantId) {
    const cart = await this.get();
    const item = cart.items.find(i => i.variant_id == variantId);
    if (!item) return;

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: CONFIG.JSON_HEADERS,
      body: JSON.stringify({
        id: item.key,
        quantity: 0
      })
    });
  }
};

function initCombo(products = []) {
  if (!document.getElementById('combo-app')) return;

  // ── Snapshot the original products so they can be restored later ──
  ORIGINAL_PRODUCTS = [...products];

  COMBO_STATE.selected = products;
  COMBO_STATE.removed = [];

  renderCombo();
}

function toggleSection(containerClass, shouldShow) {
  const el = document.querySelector(`.${containerClass}`);
  if (!el) return;
  el.style.display = shouldShow ? '' : 'none';
}

function renderCombo() {
  renderInternal();
  renderExternal();
  renderRemoved();
  renderDosage();
  renderAddons();
  recalculatePrices();
}

function renderCoreSections() {
  renderInternal();
  renderExternal();
  renderDosage();
  recalculatePrices();
}

function renderAllSections() {
  renderCoreSections();
  renderRemoved();
  renderAddons();
  recalculatePrices();
}

function renderProductCard(p) {
  const imgUrl = getProductImageUrl(p.product_image);
  const bundleData = bundleMap.bundle1.find(b => String(b.variantId) === String(p.variant_id));
  const rawPrice = window.API_PRICE_MAP?.[String(p.variant_id)] || bundleData?.price || p.price || '';
  
  const price = rawPrice ? `₹${parseFloat(rawPrice)}` : '';
  const isFreeProduct = String(p.variant_id) === "45277154377906";
  const ingredientImgs = p.ingredients.slice(0, 2).map(i =>
    `<img src="${i.image}" alt="${i.name}" title="${i.name}" />`
  ).join('');
  const ingredientName = p.ingredients.slice(0, 2).map(i =>
    `<p class="ingredient-name">${i.name}</p> 
    <svg xmlns="http://www.w3.org/2000/svg" class="ingredient-dot" width="4" height="4" viewBox="0 0 4 4" fill="none">
      <path d="M0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2C4 3.10457 3.10457 4 2 4C0.895431 4 0 3.10457 0 2Z" fill="#787878"/>
    </svg>`
  ).join('');

  return `
    <div class="product-card ${isFreeProduct ? `free-product-container` : ``}" data-id="${p.variant_id}">
      <div class="product-left">
        <img src="${imgUrl}" alt="${p.product}" onerror="this.style.display='none'" />
      </div>
      <div class="product-center">
        <div class="product-title-price-flex ${isFreeProduct ? `free-product-tag` : ``}">
          <h4 class="product-title">${p.product}</h4>
          <p class="product-price">${isFreeProduct ? `<span><del>₹199</del></span>` : `${price}`}</p>
          ${isFreeProduct ? `
            <span class="custom-diet-freetag">FREE</span>
            <button class="product-arrow-btn" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                <path d="M0.75 8.75L4.75 4.75L0.75 0.75" stroke="#5C5C5C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            ` : ``}
        </div>
        <p class="product-effect">${p.effect}</p>
        <div class="product-ingredients">
          <div class="product-ingredients-image">
          ${ingredientImgs}
          </div>
          <div class="product-ingredients-name">
          ${ingredientName}
          </div>
        </div>
      </div>
      ${isFreeProduct ? ` ` : `
        <div class="product-right">
          <div class="product-actions">
              <button class="product-arrow-btn" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                  <path d="M0.75 8.75L4.75 4.75L0.75 0.75" stroke="#5C5C5C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <button class="remove-btn" type="button" data-id="${p.variant_id}">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                  <path d="M0.599976 3.26664H12.6M11.2666 3.26664V12.6C11.2666 13.2666 10.6 13.9333 9.93331 13.9333H3.26664C2.59998 13.9333 1.93331 13.2666 1.93331 12.6V3.26664M3.93331 3.26664V1.93331C3.93331 1.26664 4.59998 0.599976 5.26664 0.599976H7.93331C8.59998 0.599976 9.26664 1.26664 9.26664 1.93331V3.26664M5.26664 6.59998V10.6M7.93331 6.59998V10.6" stroke="#999999" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
          </div>
        </div>
      `}
    </div>
  `;
}

function hasCoreProducts() {
  return COMBO_STATE.selected.some(p => p.internal || p.external);
}

function renderInternal() {
  const el = document.getElementById('internal-products');
  if (!el) return;

  const items = COMBO_STATE.selected.filter(p => p.internal);

  el.innerHTML = items.length
    ? items.map(renderProductCard).join('')
    : '<p class="combo-empty"> </p>';
}

function renderExternal() {
  const el = document.getElementById('external-products');
  if (!el) return;

  const items = COMBO_STATE.selected.filter(p => p.external);
  el.innerHTML = items.length
    ? items.map(renderProductCard).join('')
    : '<p class="combo-empty">No external products in your plan.</p>';
}

function renderRemoved() {
  const el = document.getElementById('removed-products');
  if (!el) return;

  const hasItems = COMBO_STATE.removed.length > 0;
  toggleSection('removed-products-container', hasItems);
  if (!hasItems) {
    el.innerHTML = '';
    return;
  }

  el.innerHTML = COMBO_STATE.removed.map(p => {
    const rawPrice = window.API_PRICE_MAP?.[String(p.variant_id)] || p.price || '';
    const price = rawPrice ? `₹${parseFloat(rawPrice)}` : '';
    const imgUrl = getProductImageUrl(p.product_image);
    return `
      <div class="removed-card" data-id="${p.variant_id}">
        <div class="removed-left">
          <img src="${imgUrl}" alt="${p.product}" onerror="this.style.display='none'" />
        </div>
        <div class="removed-center">
          <p>${p.product}</p>
          <p class="product-price">${price}</p>
        </div>
        <div class="removed-right">
          <button class="add-back-btn" data-id="${p.variant_id}">Add to Cart</button>
        </div>
      </div>
    `;
  }).join('');
}

function renderWashItems(products) {
  return products.map(p => {
    const imgUrl = getProductImageUrl(p.product_image);
    const value = normalizeDosageText(p.dosage?.hair_wash_day || '');
    return `
      <div class="dosage-wash-item">
        <img src="${imgUrl}" />
        <div>
          <p class="dosage-name">${p.product}</p>
          <p class="dosage-value">${value}</p>
        </div>
      </div>
    `;
  }).join('');
}

function renderDosage() {
  const el = document.getElementById('dosage-section');
  if (!el) return;

  const morning = COMBO_STATE.selected.filter(p => p.dosage?.morning);
  const night   = COMBO_STATE.selected.filter(p => p.dosage?.night);
  const wash    = COMBO_STATE.selected.filter(p => p.dosage?.hair_wash_day);

  if (!morning.length && !night.length && !wash.length) {
    el.innerHTML = '';
    toggleSection('dosage-section-container', false);
    return;
  }

  const isColumnLayout = morning.length > 2 || night.length > 2;
  toggleSection('dosage-section-container', true);
  const isWashColumnLayout = wash.length > 2;

  el.innerHTML = `
    <div class="dosage-wrapper">
      ${(morning.length || night.length) ? `
        <div class="dosage-everyday">
          <h3 class="dosage-heading">EVERYDAY ROUTINE</h3>
          <div class="dosage-everyday-grid ${isColumnLayout ? 'column-layout' : 'row-layout'}">
            ${renderDosageCard('Morning • 2 mins', morning, 'morning')}
            ${renderDosageCard('Night • 2 mins', night, 'night')}
          </div>
        </div>
      ` : ''}
      ${wash.length ? `
        <div class="dosage-wash">
          <h3 class="dosage-heading">HAIR WASH DAY ROUTINE</h3>
          <div class="dosage-wash-container">
            <p class="dosage-wash-subtext">
              2x per week for Dry scalp / 3x per week for Oily scalp
            </p>
            <div class="dosage-wash-grid ${isWashColumnLayout ? 'column-layout' : ''}">
              ${renderWashItems(wash)}
            </div>
          </div>
        </div>
      ` : ''}
    </div>
  `;
}

function renderDosageCard(title, products, type) {
  if (!products.length) return '';

  return `
    <div class="dosage-card-box">
      <div class="dosage-card-header">${title}</div>
      <div class="dosage-card-list">
        ${products.map(p => {
          const imgUrl = getProductImageUrl(p.product_image);
          const value = normalizeDosageText(p.dosage[type]);
          return `
            <div class="dosage-item">
              <img src="${imgUrl}" />
              <div>
                <p class="dosage-name">${p.product}</p>
                <p class="dosage-value">${value}</p>
              </div>
            </div>
          `;
        }).join('')}
      </div>
    </div>
  `;
}

const bundleMap = {
  bundle1: [
    {
      "variantId": "44650256728242",
      "name": "Defence conditioner",
      "image_url": "https://dvv8w2q8s3qot.cloudfront.net/products/product_single_images/defenceConditioner50mg1.png",
      "one_liner": "Conditions and Smoothens Hair Texture",
      "tag": "Softens Hair",
      "price": "320.00"
    },
    {
      "variantId": "47301151064242",
      "name": "Defence Shampoo",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Product_1_86e4caf1-109f-4f35-a88c-3bc4b35e869c.webp?v=1763373344",
      "one_liner": "Hydrates Deeply and Reduces Dryness",
      "tag": "Cleans scalp",
      "price": "267.00",
      "originalPrice": "300"
    },
    {
      "variantId": "46528923304114",
      "name": "Anti Dandruff Lotion",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti_Dandruff_Solution.webp?v=1765353677",
      "one_liner": "Night Lotion fights dandruff to help reduce hair fall.",
      "tag": "Clears Dandruff",
      "price": "355.00",
      "originalPrice": "399"
    },
    {
      "variantId": "47303097352370",
      "name": "hair vitamin for her",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property.webp?v=1766144058",
      "one_liner": "Supplements to meet Hair's Nutrition needs.",
      "tag": "Nourishes Hair",
      "price": "463.00",
      "originalPrice": "520"
    },
    {
      "variantId": "47301148803250",
      "name": "Shine serum",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/shine_leave_in_serum.webp?v=1771394293",
      "one_liner": "Shine Serum enhances hair texture for a vibrant, healthy look.",
      "tag": "Adds Shine",
      "price": "599.00"
    },
    {
      "variantId": "47329496826034",
      "name": "Anti-Dandruff Shampoo",
      "image_url": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti_Dandruff_Shampoo2.webp?v=1765353725",
      "one_liner": "Anti-Dandruff Shampoo fights dandruff to help reduce hair fall.",
      "tag": "Clears dandruff",
      "price": "281.00",
      "originalPrice": "300"
    }
  ]
};

const ADDON_IDS = bundleMap.bundle1.map(p => String(p.variantId));

function renderAddons() {
  const el = document.getElementById('addons-section');
  if (!el) return;

  const addons = ALL_PRODUCTS.filter(p => {
    const id = String(p.variant_id);
    return (
      ADDON_IDS.includes(id) &&
      !COMBO_STATE.selected.some(s => String(s.variant_id) === id) &&
      !COMBO_STATE.removed.some(r => String(r.variant_id) === id)
    );
  });

  const bundleLookup = Object.fromEntries(
    bundleMap.bundle1.map(item => [String(item.variantId), item])
  );

  if (!addons.length) {
    el.innerHTML = '<p class="combo-empty">No add-ons available.</p>';
    return;
  }

  el.innerHTML = addons.map(p => {
    const imgUrl = getProductImageUrl(p.product_image);
    const bundleData = bundleLookup[String(p.variant_id)];
    const rawPrice = bundleData?.price;
    const price = rawPrice ? `₹${parseFloat(rawPrice)}` : '';
    return `
      <div class="addon-card" data-id="${p.variant_id}">
        <div class="addon-left">
          <img src="${imgUrl}" alt="${p.product}" />
        </div>
        <div class="addon-center">
          <p>${p.product}</p>
          <p class="addon-product-effect">${bundleData?.tag || ''}</p>
          <p class="addons-price">${price}</p>
        </div>
        <div class="addon-right">
          <button class="add-addon-btn" data-id="${p.variant_id}">Add to Cart</button>
        </div>
      </div>
    `;
  }).join('');
}

// ─── CLICK HANDLER ────────────────────────────────────────────────────────────

document.addEventListener('click', async (e) => {

  // OPEN REMOVE POPUP
  if (e.target.closest('.remove-btn')) {
    const id = e.target.closest('.remove-btn').dataset.id;
    const product = COMBO_STATE.selected.find(p => String(p.variant_id) === String(id));
    if (!product) return;

    trackMoengageEvent('delete_product_clicked');

    COMBO_STATE.pendingRemove = product;
    const popupTitle    = document.getElementById('popup-title');
    const popupImage    = document.getElementById('popup-image');
    const popupOneLiner = document.querySelector('.remove-popup-oneliner');
    if (popupTitle)    popupTitle.innerText = product.product;
    if (popupImage)    popupImage.src = getProductImageUrl(product.product_image);
    if (popupOneLiner) popupOneLiner.innerText = product.effect || '';
    document.getElementById('remove-popup')?.classList.add('active');
  }

  // CONFIRM REMOVE
  if (e.target.id === 'confirm-remove') {
    const btn = e.target;
    if (btn.disabled) return;

    const product = COMBO_STATE.pendingRemove;
    if (!product) return;

    btn.disabled = true;
    btn.innerHTML = LOADER_BTN;

    await CartManager.remove(product.variant_id);

    trackMoengageEvent('delete_product');
    COMBO_STATE.selected = COMBO_STATE.selected.filter(
      p => p.variant_id !== product.variant_id
    );

    // Origin-aware routing:
    // - If the product was in the initial API response (internal-products-wrapper-bg),
    //   send it to the removed section.
    // - If it was added from the addons section, don't push it to `removed` — leaving
    //   it out of both `selected` and `removed` lets renderAddons surface it again.
    const isFromOriginalProducts = ORIGINAL_PRODUCTS.some(
      p => String(p.variant_id) === String(product.variant_id)
    );

    if (isFromOriginalProducts) {
      COMBO_STATE.removed.push(product);
    }

    btn.disabled = false;
    btn.innerHTML = 'Remove';

// ✅ NEW LOGIC (same as your snippet)
  const updatedCart = await fetch('/cart.js').then(res => res.json());

  if (updatedCart.items.length === 1) {
    showEmptyCartPopup();

    const productListWrapper = document.querySelector('.product-combo-details');
    if (productListWrapper) {
      const allProductCards = productListWrapper.querySelectorAll('.product-card');
      allProductCards.forEach(card => card.remove());
    }

    renderAllSections();
    updateCartDrawer();
    return;
  }

  // existing logic
  if (COMBO_STATE.selected.length === 0) {
    showEmptyCartPopup();
    renderAllSections();
    updateCartDrawer();
    return;
  }

    closePopup();
    renderAllSections();
    updateCartDrawer();

  }

  // CANCEL REMOVE
  if (e.target.id === 'cancel-remove') {
    closePopup();
  }

  // ADD BACK (removed products)
  if (e.target.closest('.add-back-btn')) {
    const btn = e.target.closest('.add-back-btn');
    if (btn.disabled) return;

    const id = btn.dataset.id;
    const product = COMBO_STATE.removed.find(p => String(p.variant_id) === String(id));
    if (!product) return;

    btn.disabled = true;
    btn.innerHTML = LOADER_BTN;

    await CartManager.add(id);

    COMBO_STATE.removed = COMBO_STATE.removed.filter(p => String(p.variant_id) !== String(id));
    COMBO_STATE.selected.push(product);

    renderAllSections();
    updateCartDrawer();
  }

  // ADD ADDON
  if (e.target.closest('.add-addon-btn')) {
    const btn = e.target.closest('.add-addon-btn');
    if (btn.disabled) return;

    const id = btn.dataset.id;
    const product = ALL_PRODUCTS.find(p => String(p.variant_id) === String(id));
    if (!product) return;

    btn.disabled = true;
    btn.innerHTML = LOADER_BTN;

    await CartManager.add(id);

    trackMoengageEvent('addon_add_to_cart_click');

    applyDosagePatch(product);
    COMBO_STATE.selected.push(product);

    renderCoreSections();
    renderAddons();
    updateCartDrawer();
  }

  // CLOSE POPUP via overlay click
  if (e.target.classList.contains('remove-overlay')) {
    closePopup();
  }

  // OPEN PRODUCT DRAWER
// OPEN PRODUCT DRAWER
  if (e.target.closest('.product-card') && !e.target.closest('.remove-btn')) {
    const card = e.target.closest('.product-card');
    const variantId = card.dataset.id;
    if (!variantId) return;

    trackMoengageEvent('web_product_card_clicked');

    openProductDrawer(variantId);
  }
  // MOENGAGE: video testimonial play button clicked
  if (e.target.closest('.rewamp-testimonial-videos-play-btn')) {
    trackMoengageEvent('Video_thumbnail_clicked');
  }

if (e.target.id === 'go-back-to-original-cart') {
  window.location.reload();
}

}); // ← closing of document click listener

// ─── EMPTY CART POPUP ────────────────────────────────────────────────────────
function showEmptyCartPopup() {
  // Fetch cart state first to avoid calling clear.js on an already-empty cart.
  // Excessive clear.js calls on empty carts trigger Cloudflare bot detection on Shopify's CDN.
  fetch('/cart.js').then(r => r.json()).then(cartState => {
    if ((cartState.item_count || 0) > 0) fetch('/cart/clear.js', { method: 'POST' });
  });

  qsa('#add-to-cart-result-page-frp').forEach(btn => {
    btn.disabled = true;
    btn.classList.add('loader-added');
  });

  const popup = document.getElementById('remove-popup');
  if (!popup) return;

  popup.innerHTML = `
    <div class="remove-overlay"></div>
    <div class="remove-popup-box empty-cart-popup-box">
      <div class="empty-cart-image-wrapper">
        <img
          src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Kit_Image_ecd62d94-cff1-4a85-a9ef-0ba90cd688f6.png?v=1776262696"
          alt="Traya"
          width="160"
          height="160"
          onerror="this.style.display='none'"
        />
      </div>
      <h2 class="empty-cart-title">Your Cart is Empty</h2>
      <p class="empty-cart-msg">You have removed all products in your kit!</p>
      <button id="go-back-to-original-cart" class="go-back-btn">
        Go Back to Original Cart
      </button>
    </div>
  `;

  popup.classList.add('active');
  document.body.style.overflow = 'hidden';
}
// ─────────────────────────────────────────────────────────────────────────────

// ─── PRODUCT DRAWER ───────────────────────────────────────────────────────────
function isMobileDevice() {
  return window.innerWidth <= 767;
}

function openProductDrawer(variantId) {
  const popup = document.getElementById('product-popup');
  const drawerOverlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  if (!popup || !drawerOverlay || !popupContentPlaceholder) return;

  popupContentPlaceholder.innerHTML = `
    <iframe src="https://form.traya.health/product-drawerv2/${variantId}?language=english" frameborder="0" width="100%" height="100%"></iframe>
  `;

  if (isMobileDevice()) {
    popup.style.bottom = '0';
  } else {
    popup.style.right = '0';
  }

  drawerOverlay.style.display = 'block';
  document.body.classList.add('drawer-open'); // ← add
  document.body.style.overflow = 'hidden';
}

function closeProductDrawer() {
  const popup = document.getElementById('product-popup');
  const drawerOverlay = document.getElementById('background-overlay');
  if (!popup || !drawerOverlay) return;

  if (isMobileDevice()) {
    popup.style.bottom = '-100%';
  } else {
    popup.style.right = '-100%';
  }

  drawerOverlay.style.display = 'none';
  document.body.classList.remove('drawer-open'); // ← add
  document.body.style.overflow = '';
}

document.getElementById('close-popup')?.addEventListener('click', closeProductDrawer);
document.getElementById('background-overlay')?.addEventListener('click', closeProductDrawer);

function closePopup() {
  document.getElementById('remove-popup')?.classList.remove('active');
  COMBO_STATE.pendingRemove = null;
}

function initResultsSlider(selector) {
  const $slider = $(selector);
  if (!$slider.length) return;
  if ($slider.hasClass('slick-initialized')) return;

  $slider.on('init reInit afterChange', function(event, slick, currentSlide) {
    const current = currentSlide ? currentSlide : 0;
    const total = slick.slideCount;
    const dots = this.querySelectorAll('.slick-dots li');
    dots.forEach((dot, index) => {
      const button = dot.querySelector('button');
      if (index === current) {
        button.innerHTML = `${current + 1}/${total}`;
        dot.classList.add('slick-counter-active');
      } else {
        button.innerHTML = '';
        dot.classList.remove('slick-counter-active');
      }
    });
  });

  $slider.slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2.6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

function initResultsPopup() {
  const triggerBtn = document.querySelector('.pagination-arrow-flex');
  const overlay = document.querySelector('.results-popup-overlay');
  const popup = document.querySelector('.results-popup');
  const closeBtn = document.querySelector('.results-popup-close');
  const popupContent = document.querySelector('.results-popup-content');

  if (!triggerBtn || !overlay || !popup || !popupContent) return;

  let cachedHTML = null;
  let fetchPromise = null;

  function fetchPage() {
    if (fetchPromise) return fetchPromise;

    fetchPromise = fetch('/pages/clinical-study-v2')
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        
        const content = 
          doc.querySelector('main') || 
          doc.querySelector('.main-content') ||
          doc.querySelector('#MainContent') ||
          doc.body;

        cachedHTML = content.innerHTML;
        console.log('Fetched HTML length:', cachedHTML?.length, 'Element found:', content?.tagName);
        return cachedHTML;
      })
      .catch(err => {
        console.error('Page load failed:', err);
        fetchPromise = null;
      });

    return fetchPromise;
  }

  fetchPage();

  triggerBtn.addEventListener('click', () => {
    trackMoengageEvent('clinical_study_entry_point_clicked');
    openPopup();
  });

  closeBtn?.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);

  function openPopup() {
    overlay.classList.add('active');
    popup.classList.add('active');
    popup.scrollTop = 0;

    popupContent.innerHTML = `<p style="padding:20px;text-align:center;">Loading...</p>`;

    fetchPage().then((html) => {
      if (!html) {
        popupContent.innerHTML = `<p style="padding:20px;text-align:center;">Failed to load content.</p>`;
        return;
      }
      renderPopup();
    });
  }

  function renderPopup() {
    popupContent.innerHTML = cachedHTML;
    initResultsSlider('.journey-slider');
    initResultsSlider('.data-slider');
  }

  function closePopup() {
    overlay.classList.remove('active');
    popup.classList.remove('active');
  }
}